import {LinkImageCard} from '@/components/content-blocks/link-list-selection/link-image-card';
import type {LinkListSelectionFragment} from '@/components/content-blocks/link-list-selection/query';
import {cn} from '@/modules/foundation/shared/tailwind';

type Props = {
	linkItems: LinkListSelectionFragment['linkItems'];
	headingLevel?: 2 | 3;
};

export const GridImages = ({linkItems, headingLevel}: Props) => {
	if (!linkItems?.length) {
		return null;
	}

	return (
		<div
			className={cn(
				'grid',
				'grid-cols-[repeat(auto-fill,_minmax(min(600px,_100%),_1fr))]',
				'gap-4',
				'md:gap-8',
				'ml-auto',
				'mr-auto',
			)}
		>
			{linkItems.map((linkItem) => {
				return (
					<LinkImageCard
						key={linkItem._key}
						linkItem={linkItem}
						headingLevel={headingLevel}
					/>
				);
			})}
		</div>
	);
};
